import React, { FC, useState, useEffect } from 'react'

import './style.scss'
import { utils } from '../../../utils'
import { FormResponseStatus } from '../../../models'
import { Button, Card, FormMessageError, FormMessageSuccess, Icon, Loading, Paginate, Table, TableLabel, TableText, Text } from '../../UI'
import { Modal, useModal } from '../../UI/Modal'
import { ExamsLaboratoryForm, FamilyGroupFilter } from '..'
import { examService } from '../../../services'

type ExamsLaboratoryProps = {
  className?: string,
  data: {
    data: any[],
    pagination: {
      page: number,
      limit: number,
      total: number,
      totalPages: number,
      hasNext: boolean,
      hasPrev: boolean
    }
  } | null,
  loading?: boolean,
  relationshipTypes: any[],
  familyFilter: any,
  familyFilterSelected: string,
  onFamilyFilterChange?(patientId: string): void,
  onPageChange?(page: number): void
}

const ExamReservationButton = () => {
  const onExamReservation = () => (window as any).show_chat('362,363,364', null)

  return <Button size="md" onClick={onExamReservation}>RESERVA DE EXÁMENES</Button>
}

const ExamsLaboratory:FC<ExamsLaboratoryProps> = ({ 
  className = '', 
  data, 
  loading = false, 
  relationshipTypes, 
  familyFilter, 
  familyFilterSelected, 
  onFamilyFilterChange,
  onPageChange 
}) => {
  const [tableAttrsShow, setTableAttrsShow] = useState<boolean[]>([])
  const [examSel, setExamSel] = useState<any>({})
  const modal = useModal()
  const modalStatus = useModal()

  // Update tableAttrsShow when data changes
  useEffect(() => {
    if (data?.data) {
      setTableAttrsShow(new Array(data.data.length).fill(false))
    }
  }, [data?.data])

  const tableColumns = [
    {
      accessor: 'type_exam',
      Header: 'Tipo de examen',
      width: '35%'
    },
    /* {
      accessor: 'area',
      Header: 'Área',
      width: '20%',
      Cell: (params: any) => {
        const { value } = params
        return (typeof value === 'string' ? value : '')
      }
    }, */
    {
      accessor: 'doctor_solicite',
      Header: 'Medico Solicitante',
      width: '35%',
      Cell: (params: any) => {
        const { value } = params
        return (typeof value === 'string' ? value : '')
      }
    },
    {
      accessor: 'date',
      Header: 'Fecha',
      width: '10%'
    },
    {
      accessor: 'hour',
      Header: 'Hora',
      width: '15%'
    },
    {
      accessor: 'attention_id',
      Header: 'Ver Descargar',
      width: '5%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="text-center">
            <a href="# " onClick={(event) => onExamFile(event, original.attention_id, original.type_patient)}>
              <Icon name="view" />
            </a>
          </div>
        )
      }
    },
    {
      accessor: 'share',
      Header: 'Compartir',
      width: '5%',
      Cell: (params: any) => {
        const { original } = params.row

        return (
          <div className="text-center">
            <a href="# " onClick={(event) => onExamShare(event, original.attention_id, original.type_patient)}>
              <Icon name="share" />
            </a>
          </div>
        )
      }
    }
  ]

  const onFilterChange = (userId: string) => {
    if(onFamilyFilterChange) onFamilyFilterChange(userId)
  }

  const onTableBtnShowMore = (index: number) => {
    setTableAttrsShow(prevState => prevState.map((item, idx) => idx === index ? !item : item))
  }

  const onExamFile = async (event: any, examId: string, patientType: string) => {
    event.preventDefault()
    const resp: any = await examService.getExamFile(examId, familyFilterSelected, patientType) // '3035741'

    if(resp.data) {
      // window.open(resp.data, '_blank')
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href: resp.data,
      }).click()
    }
  }

  const onExamShare = (event: any, examId: string, patientType: string) => {
    event.preventDefault()
    setExamSel({
      examId,
      patientType
    })
    modal.open()
  }

  const onModalStatusClose = () => {
    modalStatus.close()
    if(modalStatus.status === 'ERROR') modal.open()
  }

  const onExamsLaboratoryFormChange = (respStatus: FormResponseStatus) => {
    modal.close()
    modalStatus.setStatus(respStatus)
    modalStatus.open()
  }

  const handlePageChange = (page: number) => {
    if (onPageChange) {
      onPageChange(page)
    }
  }

  console.log(data)

  return (
    <>
      <div className={`laboratory-wrapper ${className}`}>
        <FamilyGroupFilter
          data={familyFilter.data}
          dataSelected={familyFilterSelected}
          onChange={onFilterChange}
        />

        {data ?
            data.data.length ?
                <>
                  <div className="lg:position-absolute mt-20 lg:mt-0">
                    <ExamReservationButton />
                  </div>
                  <div className="mt-20">
                    <div className="d-none lg:d-block">
                      <Table
                        columns={tableColumns}
                        data={data.data}
                      />
                    </div>

                    <div className="d-block lg:d-none">
                      {data.data.map((it: any, i: number) =>
                        <Card key={i} className={`py-20 px-25 ${i > 0 ? 'mt-20' : ''}`}>
                          <div>
                            <TableLabel>Tipo de examen</TableLabel>
                            <TableText>{it.type_exam}</TableText>
                          </div>
                          {tableAttrsShow[i] &&
                            <>
                              <div className="mt-10">
                                <TableLabel>Fecha</TableLabel>
                                <TableText>{it.date}</TableText>
                              </div>

                              <div className="mt-10">
                                <TableLabel>Hora</TableLabel>
                                <TableText>{it.hour}</TableText>
                              </div>

                              <div className="mt-10">
                                <TableLabel>Área</TableLabel>
                                <TableText>---</TableText>
                              </div>

                              <div className="mt-10">
                                <TableLabel>Médico solicitante</TableLabel>

                                { 'string' === typeof it.doctor_solicite &&
                                    <>
                                      <TableText>{it.doctor_solicite}</TableText>
                                    </>
                                }

                                {'string' != typeof it.doctor_solicite &&
                                    <>
                                      <TableText>--</TableText>
                                    </>
                                }

                              </div>

                              <div className="mt-10">
                                <a href="# " className="ml-15" onClick={(event) => onExamFile(event, it.attention_id, it.type_patient)}>
                                  <TableLabel inline>Ver / Descargar</TableLabel>
                                </a>
                                <a href="# " className="ml-15" onClick={(event) => onExamFile(event, it.attention_id, it.type_patient)}>
                                  <Icon name="view" />
                                </a>

                              </div>

                              <div className="mt-10">
                                <a href="# " className="ml-15" onClick={(event) => onExamShare(event, it.attention_id, it.type_patient)}>
                                  <TableLabel inline>Compartir</TableLabel>
                                </a>
                                <a href="# " className="ml-15" onClick={(event) => onExamShare(event, it.attention_id, it.type_patient)}>
                                  <Icon name="share" />
                                </a>
                              </div>
                            </>
                          }

                          {!tableAttrsShow[i] &&
                            <div className="text-center mt-20" onClick={() => onTableBtnShowMore(i)}>
                              <div className="d-inline px-10">
                                <Icon name="arrow-down" />
                              </div>
                            </div>
                          }
                        </Card>
                      )}
                    </div>
                  </div>

                  <div className="text-center mt-20 position-relative">
                    <Paginate
                      current={data.pagination.page}
                      total={data.pagination.total}
                      size={data.pagination.limit}
                      onPageChange={handlePageChange}
                    />
                    {loading && (
                      <div className="position-absolute d-flex align-items-center justify-content-center" style={{
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 10
                      }}>
                        <Loading size="sm" align="center" />
                      </div>
                    )}
                  </div>
                </>
              :
                <div className="laboratory-empty">
                  <Text size="14" weight="bold" className="lg:fz-20">Aún no tienes exámenes en este historial</Text>

                  <div className="text-center mt-30 lg:mt-50">
                    <ExamReservationButton />
                  </div>
                </div>
          :
            <Loading size="md" align="center" className="pt-70 lg:pt-100" />
        }
      </div>

      <Modal show={modal.show} maxWidth="415px" onClose={() => modal.close()}>
        <ExamsLaboratoryForm
          exam={examSel}
          patientId={familyFilterSelected}
          relationshipTypes={relationshipTypes}
          onSubmitChange={onExamsLaboratoryFormChange}
        />
      </Modal>

      <Modal show={modalStatus.show} maxWidth="345px" onClose={onModalStatusClose}>
        {modalStatus.status === 'SUCCESS' &&
          <FormMessageSuccess
            className="py-60 px-50"
            title="¡Examen compartido con éxito!"
            message="Será enviado al correo electrónico de tu destinatario"
          />
        }
        {modalStatus.status === 'ERROR' &&
          <FormMessageError
            className="py-60 px-50"
            message="No ha sido posible compartir el examen"
            onClick={onModalStatusClose}
          />
        }
      </Modal>
    </>
  )
}

export { ExamsLaboratory }